import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    if (window.RolexRetailerClock) {
      this.loadClock();
    } else if (!window.RolexRetailerClock && !window.loadingRolexJs) {
      window.loadingRolexJs = true;

      this.fetchClockJs().then(() => {
        window.loadingRolexJs = false;
        this.loadClock();
      });
    }
  }

  disconnect() {
    window.clocksInitialized = false;
  }

  fetchClockJs() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = 'https://static.rolex.com/retailers/clock/retailercall.js';
    });
  }

  loadClock() {
    if (!window.clocksInitialized) {
      window.clocksInitialized = true;
      const rdp = new window.RolexRetailerClock();
      const rdpConfig = {
        dealerAPIKey: '2ba54af70ff545039aa45a9fad188da4',
        lang: 'en_us',
        colour: 'gold',
      };

      rdp.getRetailerClock(rdpConfig);
    }
  }
}
